var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('apexchart',{attrs:{"height":"500","options":_vm.chartOptions,"series":_vm.activeSubstationData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }